document.addEventListener("DOMContentLoaded", function () {
  const accordions = [...document.querySelectorAll('.reusser-accordion-block')];

  if (accordions.length) {
    function toggleAccordion(event) {
      let target = event.target.closest(".question");

      if (target) {
        let answer = target.nextElementSibling;

        event.preventDefault();
        target.classList.toggle("toggled");
        target.setAttribute(
          'aria-expanded', 
          `${(target.getAttribute('aria-expanded') !== 'true').toString()}` 
        );
        if (answer !== null && answer.classList.contains('answer')) {
          // Toggle the 'hidden' attribute
          answer.hidden = !answer.hidden;
        }
      }
    }

    document.addEventListener("click", toggleAccordion);
    document.addEventListener("touchend", toggleAccordion);
  }

  // iamota accordions
  const iamotaAccordions = [...document.querySelectorAll('.iamota-accordion')];

  if (iamotaAccordions.length) {
    function toggleiamotaAccordion(event) {
      let target = event.target.closest(".accordion__title");
      let button = event.target.closest(".accordion__button");

      if (target) {
        event.preventDefault();
        target.classList.toggle("toggled");
        button.setAttribute(
          'aria-expanded', 
          `${(button.getAttribute('aria-expanded') !== 'true').toString()}` 
        );
      }
    }


    document.addEventListener("click", toggleiamotaAccordion);
    document.addEventListener("touchend", toggleiamotaAccordion);
  }

  // Warranty Bar Accordions
  const warrantyBarAccordions = [...document.querySelectorAll('.warranty-bar-accordion')];

  if (warrantyBarAccordions.length) {
    warrantyBarAccordions.forEach(element => {
      let accordion_title = element.querySelector('.accordion__title');
      function toggleWarrantyBarAccordion(event) {
        let target = event.target.closest(".accordion-title__container");
  
        if (target) {
          event.preventDefault();
          target.classList.toggle("toggled");
        }
      }
      accordion_title.addEventListener("click", toggleWarrantyBarAccordion);
      accordion_title.addEventListener("touchend", toggleWarrantyBarAccordion);
    });
  }
});